import { FC } from "react";
import { HStack, Text } from "@chakra-ui/react";

interface Props {
  title: string;
  text: string | undefined;
  variant?: "green" | "brand" | "gray";
}

export const OperationItemDetailsText: FC<Props> = (props) => {
  const {
    title,
    text,
    variant = "gray",
  } = props;

  if (!text) {
    return null;
  }

  return (
    <HStack w="100%" justifyContent="space-between" mb="1px">
      <Text fontSize="sm">{title}</Text>
      <Text variant={variant} fontSize="sm">{text}</Text>
    </HStack>
  );
};
